import { Button, Container, Grid, IconButton, Tooltip } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
// import { useHistory } from 'react-router-dom';
import UserServiceInstance from '../../services/UserService';
import IUserTag from '../../models/IUserTag';
import OntimeTable from '../common/OntimeTable';
import LoyaltyIcon from '@mui/icons-material/Loyalty';
import DeleteIcon from '@mui/icons-material/Delete';
import { useNavigate } from 'react-router-dom';
import OntimeBreadcrumb from '../common/OntimeBreadcrumb';
import ConfirmDialog from '../common/ConfirmDialog';
import { format } from 'util';

const useStyles = makeStyles((theme) => ({
    table: {
        tableLayout: 'auto'
    },
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
    },
    appBarSpacer: theme.mixins.toolbar,
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    }
}));

function TagManagement() {
    const [userTags, setUserTags] = useState<IUserTag[]>();
    const [pendingUnregisterTag, setPendingUnregisterTag] = useState<string | null>(null);
    const { t } = useTranslation("common");
    const navigate = useNavigate();
    const classes = useStyles();
    const columns = [
        { id: 'tagNumber', numeric: true, disablePadding: true, label: t("userTags.tagNumber"), searchable: true, rowId: true },
        { id: 'actions', numeric: false, disablePadding: false, label: t("commonLabels.actions"), searchable: false, sortable: false, align: 'center' },
    ];

    const tableRows = (userTags ?? []).map((tag) => ({
        ...tag,
        actions: (
            <Tooltip title={t("userTags.unregisterTag").toString()}>
                <IconButton
                    size="small"
                    aria-label={t("userTags.unregisterTag") as string}
                    onClick={(event) => {
                        event.stopPropagation();
                        setPendingUnregisterTag(tag.tagNumber);
                    }}
                >
                    <DeleteIcon fontSize="small" />
                </IconButton>
            </Tooltip>
        )
    }));

    const registerTag=()=>{
        navigate("/user/registerTag");
    }

    useEffect(() => {
        const source = axios.CancelToken.source();
        const fetchData = async () => {
            const tags = await UserServiceInstance.getUserTags(source.token);
            setUserTags(tags);
        }
        fetchData().catch(reason => {
            if (!axios.isCancel(reason)) {
                console.error(reason);
            }
        });
        return () => {
            source.cancel();
        };
    }, []);

    const handleConfirmUnregister = async () => {
        if (!pendingUnregisterTag) {
            return;
        }

        await UserServiceInstance.unregisterTag(pendingUnregisterTag);
        setUserTags((current) => current?.filter((tag) => tag.tagNumber !== pendingUnregisterTag));
        setPendingUnregisterTag(null);
    }

    return (
        <main className={classes.content}>
            <div className={classes.appBarSpacer} />
            <Container maxWidth="lg" className={classes.container}>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <OntimeBreadcrumb nameMap={{}} current={t('userTags.title')} />
                    </Grid>
                    <Grid item xs={12}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={e => registerTag()}
                            startIcon={<LoyaltyIcon />}
                        >{t("userTags.registerTag")}</Button>
                    </Grid>
                    <Grid item xs={12}>
                        <OntimeTable
                            tableItems={tableRows}
                            columns={columns}
                            defaultOrderColumn={"tagNumber"}
                            dense={false}
                            title={t("userTags.title")}
                            editable={false}
                        >

                        </OntimeTable>
                    </Grid>
                </Grid>
            </Container>
            <ConfirmDialog
                open={pendingUnregisterTag !== null}
                title={t("userTags.unregisterTag")}
                message={pendingUnregisterTag ? format(t("userTags.confirmUnregisterTag"), pendingUnregisterTag) : ''}
                onAccept={handleConfirmUnregister}
                onCancel={() => setPendingUnregisterTag(null)}
            />
        </main>
    );

}

export default TagManagement;
